import { render } from "./architectural.vue?vue&type=template&id=21b351e2&scoped=true"
import script from "./architectural.vue?vue&type=script&lang=js"
export * from "./architectural.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-21b351e2"

export default script